<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <h1 class="h1">About Us</h1>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row v-for="faq in faqs" :key="faq.id">
        <b-col>
          <b-card no-body class="mb-2">
            <b-card-header
              header-tag="header"
              class="p-1"
              style="cursor:pointer"
              @click="faq.expanded = !faq.expanded"
            >
              <span v-html="faq.title" class="t4" />
            </b-card-header>
            <b-collapse :id="faq.id" v-model="faq.expanded">
              <b-card-body v-html="faq.description" />
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
export default {
  metaInfo:{
    title: 'Faith Christian Church Evansville: About Us',
    description: 'Learn more about our church. Our mission, relevant message, contemporary communication, welcoming environment, biblical standards, gift-oriented ministry, serve others',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  data() {
    return {
      faqs: [
        {
          id: "1",
          expanded: true,
          title: "Our Mission",
          description: "Bringing people to faith and maturity in Christ."
        },
        {
          id: "2",
          expanded: true,
          title: "Relevant Message",
          description:
            "Sermons that make sense and apply to seekers, new believers and mature Christians."
        },
        {
          id: "3",
          expanded: true,
          title: "Contemporary Communication",
          description:
            "Historic Christianity shared through today's methods...everyday language and popular media and arts."
        },
        {
          id: "4",
          expanded: true,
          title: "Welcoming Environment",
          description:
            "We have no dress code, you can be as anonymous as you wish to be, but you'll be greeted with friendly smiles, you won't be pressured or manipulated because we respect the process of coming to faith in Christ."
        },
        {
          id: "5",
          expanded: true,
          title: "Biblical Standards",
          description:
            "The Bible is the basis for our faith and practice. We are a Grace-oriented loving community."
        },
        {
          id: "6",
          expanded: true,
          title: "Gift-oriented Ministry",
          description:
            "Every believer has been given spiritual gifts to use in serving others. The role of the pastors is primarily to teach, train and equip."
        },
        {
          id: "7",
          expanded: true,
          title: "Serve Others",
          description:
            "Faith Christian Church Evansville WI is built on God's love and service. There are a variety of ways in which to be involved in relationships and ministry to others."
        }
      ]
    };
  }
};
</script>